import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import InputRange from 'react-input-range';
import * as PlayerActions from '../../store/actions/player';
import {useDispatch} from 'react-redux';
import {PlayerEvent} from 'bitmovin-player';
import {useTranslation} from 'react-i18next';

const VolumeUI = ({player, startMuted, opacity, enableSound}) => {
    const [value, setValue] = useState(player.getVolume());
    const dispatch = useDispatch();
    const [isOSMuted, setIsOSMuted] = useState(startMuted);
    const [isMuted, setIsMuted] = useState(player.isMuted());
    const {t} = useTranslation();
    const timeRef = useRef(0);

    const onChangeValue = value => {
        timeRef.current = Date.now();
        setValue(value);
    };

    const toggleMute = () => {
        if (player.isMuted()) {
            player.unmute();
        } else {
            player.mute();
        }
    };

    useEffect(() => {
        if (value > 0) {
            setIsOSMuted(false);

            if (player.isMuted()) {
                player.unmute();
            }
        }
        //will ignore if muted
        if (!isOSMuted) {
            dispatch(PlayerActions.setVolume(value));
        }
        player.setVolume(value);
    }, [value, player, dispatch, isOSMuted]);

    useEffect(() => {
        player.on(PlayerEvent.VolumeChanged, event => {
            //to avoid a loop (both slider and player trying to set the value)
            //we add a check if the last change here was more then 500 milliseconds ago, and ignore otherwise
            if (Date.now() - timeRef.current > 500) {
                setValue(event.targetVolume);
            }
        });
        player.on(PlayerEvent.Muted, () => {
            setIsMuted(true);
        });
        player.on(PlayerEvent.Unmuted, () => {
            setIsMuted(false);
        });

        return () => {
            try {
                player.off(PlayerEvent.VolumeChanged);
                player.off(PlayerEvent.Muted);
                player.off(PlayerEvent.Unmuted);
            } catch (e) {}
        };
    }, [player]);

    return (
        <Container opacity={opacity}>
            {isOSMuted ? (
                <PlayContainer onClick={enableSound} cursor="pointer">
                    <img
                        src={require('../../assets/playerui/ic_audio_muted.png')}
                        alt="volume"
                    />
                    <Title>{t('ads.unmute')}</Title>
                </PlayContainer>
            ) : (
                <PlayContainer>
                    <img
                        src={
                            isMuted
                                ? require('../../assets/playerui/ic_audio_muted.png')
                                : require('../../assets/playerui/ic_audio.png')
                        }
                        alt="volume"
                        onClick={toggleMute}
                    />
                    <InputRange
                        maxValue={100}
                        minValue={0}
                        step={1}
                        value={isMuted ? 0 : value}
                        onChange={onChangeValue}
                    />
                </PlayContainer>
            )}
        </Container>
    );
};

const Container = styled.div`
    min-width: 170px;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: black;
    opacity: 0.65;
    border-radius: 6px;

    opacity: ${props => props.opacity};

    .input-range__slider {
        background: rgba(255, 255, 255, 0.65);
        border: 1px solid rgba(255, 255, 255, 0.65);
    }

    .input-range__label--max {
        display: none !important;
    }

    .input-range__track--active {
        background: white !important;
    }

    .input-range__track {
        background: rgba(255, 255, 255, 0.65) !important;
    }

    img {
        width: 28px !important;
        height: 28px !important;
        margin-right: 15px;
        cursor: pointer;
    }
`;

const Title = styled.div`
    font-family: AvenirNextRoundedStd, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: white;
    flex: 1;
    text-align: center;
    text-transform: uppercase;
`;

const PlayContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    ${props => props.cursor && `cursor: ${props.cursor};`};
    flex: 1;
    padding: 0 17px 0 13px;
`;

export default VolumeUI;
